import SearchBar from './SearchBar'

export { SearchBar }
export default SearchBar
